// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Circulares_containerPrincipal__McqRq","divPrincipal":"Circulares_divPrincipal__OhNWS","divTextos":"Circulares_divTextos__O9SXm"};